import { REMOVE_ALL_OPTIMISTIC_TROLLEY_ITEMS } from './types';

export default () => ({
  type: REMOVE_ALL_OPTIMISTIC_TROLLEY_ITEMS,
});
